import { objectOf, is } from "@altostra/type-validations";
import type { UserEventHistoryRequestStatus } from "./types";

export const isUserEventHistoryRequestStatus = objectOf<UserEventHistoryRequestStatus>({
  success: is(true),
});
